import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedEmailAddress = mutatorAction('updateAdvancedEmailAddress', function (emailAddress) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.emailAddress = emailAddress;
});
//# sourceMappingURL=updateAdvancedEmailAddress.js.map